// Cryptographic hash functions. Used for DAG entry hashing, element identity
// in replicated data types, and KeyId derivation from public keys. The primary
// hash() method returns raw bytes; hashToB64() returns a base64-encoded string
// (the B64Hash type used as a stable identifier throughout the project).
import { sha256 as nobleSha256 } from '@noble/hashes/sha2.js';
import { blake3 as nobleBlake3 } from '@noble/hashes/blake3.js';
export function stringToUint8Array(str) {
    return new TextEncoder().encode(str);
}
export function uint8ArrayToString(bytes) {
    return new TextDecoder().decode(bytes);
}
function bytesToBase64(bytes) {
    let binary = '';
    for (let i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}
export const sha256 = {
    name: 'sha-256',
    digestSize: 32,
    hash(input) {
        return nobleSha256(input);
    },
    hashToB64(input) {
        return bytesToBase64(nobleSha256(input));
    }
};
export const blake3 = {
    name: 'blake3',
    digestSize: 32,
    hash(input) {
        return nobleBlake3(input);
    },
    hashToB64(input) {
        return bytesToBase64(nobleBlake3(input));
    }
};
